import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import AjudaModuloFornecedores from './moduloFornecedores';
import AjudaModuloHome from './moduloHome';
import AjudaModuloMaisOpcoes from './moduloMaisOpcoes';
import AjudaModuloProaq from './moduloProaq';
import AjudaModuloProdutoDaf from './moduloProdutosDaf'; // Ajuste o caminho conforme necessário

const Ajuda: React.FC = () => {
  const location = useLocation();

  return (
    <Routes location={location}>
      <Route path="/home/*" element={<AjudaModuloHome />} />
      <Route path="/maisopcoes/*" element={<AjudaModuloMaisOpcoes />} />
      <Route path="/produtosdaf/*" element={<AjudaModuloProdutoDaf />} />
      <Route path="/fornecedores/*" element={<AjudaModuloFornecedores />} />
      <Route path="/proaq/*" element={<AjudaModuloProaq />} />

      {/* Padrão */}
      <Route path="*" element={<div>Em desenvolvimento</div>} />
    </Routes>
  );
};

export default Ajuda;
